<template>
    <div class="h-screen flex bg-surface-100 dark:bg-surface-900">
        <!-- Sidebar desktop - nascosta nel login -->
        <div 
            v-if="!isLoginRoute"
            class="hidden lg:block border-r border-surface-200 dark:border-surface-700 bg-white dark:bg-surface-800"
        >
            <Navigation />
        </div>

        <!-- Overlay per mobile -->
        <Transition
            enter-active-class="transition-opacity ease-linear duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity ease-linear duration-300"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div 
                v-if="showMobileMenu && !isLoginRoute" 
                class="fixed inset-0 bg-surface-900/50 backdrop-blur-sm lg:hidden z-[70]"
                @click="showMobileMenu = false"
            />
        </Transition>

        <!-- Sidebar mobile -->
        <Transition
            enter-active-class="transition ease-in-out duration-300 transform"
            enter-from-class="-translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transition ease-in-out duration-300 transform"
            leave-from-class="translate-x-0"
            leave-to-class="-translate-x-full"
        >
            <div 
                v-if="showMobileMenu && !isLoginRoute" 
                class="fixed inset-y-0 left-0 w-80 bg-white dark:bg-surface-800 shadow-xl lg:hidden z-[80]"
            >
                <Navigation @navigate="showMobileMenu = false" />
            </div>
        </Transition>

        <!-- Main content -->
        <main class="flex-1 flex flex-col overflow-hidden">
            <!-- Header mobile -->
            <div 
                v-if="!isLoginRoute"
                class="h-16 flex lg:hidden items-center px-4 border-b border-surface-200 dark:border-surface-700 bg-white dark:bg-surface-800"
            >
                <button 
                    class="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-surface-100 dark:hover:bg-surface-700"
                    @click="showMobileMenu = true"
                >
                    <span class="material-symbols-outlined">menu</span>
                </button>
            </div>

            <!-- Page content -->
            <div class="flex-1 overflow-hidden">
                <RouterView v-slot="{ Component }">
                    <Transition 
                        name="fade" 
                        mode="out-in"
                        appear
                    >
                        <div :key="route.path" class="h-full">
                            <component :is="Component" />
                        </div>
                    </Transition>
                </RouterView>
            </div>
        </main>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useDark } from '@vueuse/core';
import Navigation from '@/components/navigations/Navigation.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const darkMode = useDark();
const showMobileMenu = ref(false);

// Computed per verificare se siamo nella pagina di login
const isLoginRoute = computed(() => route.name === 'login');
</script>

<style>
/* Transizioni di pagina */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>